import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Paper, Typography, ButtonBase } from '@mui/material';
import { ListCheckIcons, SettingsIcons } from '../../../../icons/icons';
import { MainLayout } from '../../../../ui';
import { Config } from './Config';
import { Results } from './Results';

export const Psychometric: React.FC = () => {
  const [currentSubTab, setCurrentSubTab] = useState<'Config' | 'Results'>('Config');
  const { id } = useParams<{ id: string }>();

  const sidebarButtons = useMemo(
    () => [
      { label: 'Config', Icon: SettingsIcons, disabled: false },
      { label: 'Results', Icon: ListCheckIcons, disabled: false },
    ],
    [],
  );

  const handleSidebarChange = (tab: 'Config' | 'Results') => {
    setCurrentSubTab(tab);
  };

  return (
    <Box sx={{ display: 'flex', mt: 2.5, gap: 3 }}>
      <Paper
        elevation={0}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
          width: 80,
          py: 2,
          px: 1,
          bgcolor: 'grey.50',
          border: '1px solid',
          borderColor: 'grey.200',
          borderRadius: 4,
          flexShrink: 0,
          height: 'fit-content',
          position: 'sticky',
          top: 20,
        }}
      >
        {sidebarButtons.map((button, index) => {
          if (button.disabled) return null;
          const isActive = currentSubTab === button.label;
          const Icon = button.Icon;
          return (
            <ButtonBase
              key={index}
              onClick={() => handleSidebarChange(button.label as 'Config' | 'Results')}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                borderRadius: 2,
                py: 0.5,
              }}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: 3,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s ease',
                  border: '1px solid',
                  ...(isActive
                    ? {
                        bgcolor: 'primary.main',
                        borderColor: 'primary.main',
                        color: 'common.white',
                        boxShadow: 2,
                        transform: 'scale(1.05)',
                      }
                    : {
                        bgcolor: 'background.paper',
                        borderColor: 'grey.300',
                        color: 'text.secondary',
                        '&:hover': {
                          borderColor: 'primary.light',
                          color: 'primary.main',
                        },
                      }),
                }}
              >
                <Icon size={20} color={isActive ? "#ffffff" : "#94a3b8"} />
              </Box>
              <Typography
                variant='caption'
                sx={{
                  fontSize: '0.625rem',
                  mt: 0.5,
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  textAlign: 'center',
                  color: isActive ? 'primary.main' : 'text.secondary',
                }}
              >
                {button.label}
              </Typography>
            </ButtonBase>
          );
        })}
      </Paper>
      <MainLayout>
        {currentSubTab === 'Config' ? <Config /> : <Results jobOpeningId={id} />}
      </MainLayout>
    </Box>
  );
};